/* eslint-disable react/forbid-prop-types,import/prefer-default-export */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CurrencyIcon from '../../../components/CurrencyIcon';
import BasicContainer from '../../../components/BasicContainer';

// this component is the same as AddAccount component in accounts/partials
export const ActionButton = ({
  label = null,
  subLabel = null,
  onClick,
  disabled = null,
  className = '',
  icon,
  iconSize = 'text-f4',
  isConnectYourAccount = true,
  isImg = false,
  imageStyle = {},
  withoutAction = false,
}) => {
  const { t: translate } = useTranslation();
  if (!isConnectYourAccount) {
    return <></>;
  }

  return (
    <>
      {/* mobile layout */}
      <div
        onClick={disabled ? undefined : (e) => onClick(e)}
        aria-hidden="true"
        className="d-flex d-md-none flex-column justify-content-end">
        <div className="d-flex align-items-center">
          <p className={`text-f6 text-bold ${disabled ? 'text-disabled' : 'text-white'}`}>
            {label || translate('add_accounts_label')}
          </p>
          <i
            style={{ fontSize: '1.12rem' }}
            className={`icon icon-add-outline cursor-pointer ms-2 ${
              disabled ? 'text-disabled' : 'text-white'
            }`}
            role="button"
            aria-label={label || translate('manage_your_accounts_label')}
            tabIndex={0}
          />
        </div>
      </div>

      {/*  browser layout */}
      <BasicContainer
        className={`d-none d-md-block ${className} ${subLabel ? 'py-3' : ''} ${
          !withoutAction ? 'cursor-pointer hover-container' : ''
        } bg-lighter px-4 ${disabled ? 'disabled-block' : ''}`}
        onClick={onClick}>
        <div
          className={`d-flex flex-row align-items-center ${
            !withoutAction ? 'justify-content-between' : 'justify-content-start'
          }`}>
          {isImg && <CurrencyIcon currencyCode={icon} style={imageStyle} className="m-0 d-flex" />}

          {!Array.isArray(icon) && !isImg && (
            <div
              className="bg-light d-flex justify-content-center"
              style={{ borderRadius: '24px', padding: '0.75rem' }}>
              <i className={`icon ${icon} ${iconSize} text-white action-btn-custom`} />
            </div>
          )}

          {Array.isArray(icon) && !isImg && (
            <span
              style={{ width: '1.5rem', height: '1.5rem' }}
              className={`icon ${icon[0]} text-f4 text-white action-btn-custom`}>
              {[...Array(icon[1] + 1).keys()].map((v) => {
                if (v !== 0) {
                  return <span key={`item-${v}`} className={`path${v}`} />;
                }
                return '';
              })}
            </span>
          )}

          <div className={`col-9 ms-2 ${!withoutAction ? '' : 'ms-4'}`}>
            <p>
              <b>{label}</b>
            </p>
            {subLabel && <p className="text-shadow text-f6">{subLabel}</p>}
          </div>
          {!withoutAction && (
            <i
              style={{ width: '1rem' }}
              className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
              role="button"
              aria-label={label}
              tabIndex={0}
              onKeyDown={() => {}}
              onClick={() => {}}
            />
          )}
        </div>
      </BasicContainer>
    </>
  );
};

ActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  disabled: PropTypes.bool,
  subLabel: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  isConnectYourAccount: PropTypes.bool,
  isImg: PropTypes.bool,
  imageStyle: PropTypes.object,
  iconSize: PropTypes.string,
  withoutAction: PropTypes.bool,
};
